<template>
    <modal @before-open="beforeOpen"
           name="AdminMemberModal"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :max-width="600"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto"
           width="50%"
           :scrollable="true"
           classes="popupcontainer"
    >
        <level-history-modal :userId="member.id"></level-history-modal>
        <div class="popupcontainer container">
            <div class="modalHeader">
                <h4>
                    권한 : {{member.roleNames == "ADMIN" ? '관리자' : '없음'}}
                    <button :class="member.roleNames == 'ADMIN' ? 'btn btn-outline-danger float-right' : 'btn btn-outline-primary float-right'" @click="popupToggle('권한변경',member.roleNames == 'ADMIN' ? '권한을 회수하시겠습니까?' : '권한을 부여하시겠습니까?' , memberAdmin)" style="margin-left:5px">{{member.roleNames == "ADMIN" ? '권한회수' : '권한부여'}}</button>
                </h4>
            </div>
            <div class="container text-center" style="padding: 1em;">
                <img :src="member.profileImage ?  member.profileImage : require('@/assets/img/profile_base.png')"   @error="member.profileImage=require('@/assets/img/profile_base.png')"  style="width:100px; height:100px;" class="img-profile rounded-circle rounded mx-auto d-block" ><br>
                <div class="">
                    <h4>{{member.name}}
                        <span class="badge badge-pill badge-secondary" style="font-size:12px">
                        Lv.{{$root.$children[0].getLevelByMinute(member.volunteerMinute) ?$root.$children[0].getLevelByMinute(member.volunteerMinute).level : 0}}
                    </span>
                    </h4>
                </div>
                <p style="word-break:break-all;">{{member.introduce}}</p>
                <p class="alert-success" >메모(관리자전용)
                    <textarea class="form-control" v-model="member.memo" @blur="memberModified()">
                    </textarea>
                </p>
<!--                <button class="btn btn-outline-danger" @click="popupToggle('비밀번호 초기화','비밀번호를 초기화 하시겠습니까? *초기화 비밀번호 : 00000000' , memberPasswordReset)">비밀번호 초기화</button>-->

                <button type="button" class="btn btn-outline-danger" data-toggle="modal" data-target="#exampleModal" data-whatever="@getbootstrap" data-backdrop="false">비밀번호 변경</button>
                <!-- 패스워드 변경 모달 -->
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">비밀번호 변경</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="recipient-name" class="col-form-label">임시 비밀번호</label>
                                    <input v-model="tmp_password" type="text" class="form-control" id="recipient-name">
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">닫기</button>
                                <button type="button" class="btn btn-primary" @click="memberPasswordReset(tmp_password)">변경하기</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <table class="table table-borderless text-center">
                <thead>
                <tr>
                    <th scope="col">성별/나이</th>
                    <th scope="col">
                        {{member.genderName}}/{{$root.$children[0].getAgeString(member.age)}}
                        <span class="alert-success">{{member.age}}생</span>

                        <button v-if="$auth.user().roleNames.includes('ADMIN')" type="button" class="btn btn-outline-danger" data-toggle="modal" data-target="#genderChangeModal" data-whatever="@getbootstrap" data-backdrop="false">변경</button>
                        <!-- 성별 변경 모달 -->
                        <div class="modal fade" id="genderChangeModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="genderChangeModalLabel">정보 변경</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-group">
                                            <label>성별</label>
                                            <div class="btn-group input-group" role="group">
                                                <button type="button" class="btn" :class="{'btn-primary' : member.gender == 'MALE', 'btn-outline-secondary' : member.gender != 'MALE'}" @click="member.gender = 'MALE'">남</button>
                                                <button type="button" class="btn" :class="{'btn-primary' : member.gender == 'FEMALE', 'btn-outline-secondary' : member.gender != 'FEMALE'}" @click="member.gender = 'FEMALE'">여</button>
                                                <button type="button" class="btn" :class="{'btn-primary' : member.gender == 'ETC', 'btn-outline-secondary' : member.gender != 'ETC'}" @click="member.gender = 'ETC'">기타</button>
                                            </div>
                                            <br/>
                                            <label>생년월일</label>
                                            <div class="form-group input-group">
<!--                                                <datePicker  placeHolder="생일" v-model="member.age" :config="options" ></datePicker>-->
                                                <input class="form-control" placeHolder="생년월일을 입력해주세요 ex)19950220" v-model="member.age" type="number" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">닫기</button>
                                        <button type="button" class="btn btn-primary" @click="memberChangeGender">변경하기</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr class="alert-success">
                    <td>OT수강</td>
                    <td>
                        {{member.isEducatedOT ? '수강함' : '미수강'}}
                        <button v-if="$auth.user().roleNames.includes('ADMIN')" :class="member.isEducatedOT ? 'btn btn-outline-primary' :  'btn btn-outline-danger'"
                                @click="memberToggleIsEducatedOT">{{member.isEducatedOT ? "미수강" : "수강함" }}</button>
                    </td>
                </tr>
                <tr class="alert-success">
                    <td>기부</td>
                    <td>
                        {{member.isDonation ? '기부내역있음': '기부내역없음'}}
                        <button v-if="$auth.user().roleNames.includes('ADMIN')" :class="member.isDonation ? 'btn btn-outline-primary' :  'btn btn-outline-danger'"
                                @click="memberToggleIsDonation">{{member.isDonation ? "내역없음" : "내역있음" }}</button>
                    </td>
                </tr>
                <tr class="alert-success">
                    <td>이메일</td>
                    <td>{{member.email}} {{member.isEmailAuthorized ? '(인증)' : '(미인증)'}}</td>
                </tr>
                <tr  class="alert-success">
                    <td>핸드폰</td>
                    <td>{{member.phoneNumber}} {{member.isPhoneAuthorized ? '(인증)' : '(미인증)'}} </td>
                </tr>
                <tr  class="alert-success">
                    <td>VMS 아이디</td>
                    <td>{{member.vmsId}} {{member.vmsId ? '':'없음'}} </td>
                </tr>

                <tr>
                    <td>특기</td>
                    <td>
                        <div v-if="member.specialities.length > 0">
                            <span v-for="spec in member.specialities" v-bind:key="spec">
                                {{specialities[spec]}}
                            </span>
                        </div>
                        <span v-if="member.specialities.length == 0">
                                없음
                            </span>
                    </td>
                </tr>
                <tr>
                    <td>봉사시간</td>
                    <td>
                        {{member.volunteerMinute}}분 ({{parseInt(member.volunteerMinute/60)}}시간)
                        <button type="button" class="btn btn-outline-secondary"  @click="showExpModal">자세히</button>
                        <br>
                        <div v-if="$auth.user().roleNames.includes('ADMIN')" class="input-group col-sm-12 col-md-12 pull-right my-1">
                            <input type="number" v-model="exp"   aria-describedby="button-addon2" class="form-control">
                            <div class="input-group-append">
                                <button type="button" id="button-addon2" class="btn btn-outline-secondary"  @click="addExp">시간(분) 부여</button>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>가입일</td>
                    <td v-text="$root.$children[0].dateFormat(member.createdDate, 'YYYY.MM.DD')"></td>
                </tr>
                <tr :class="member.isKaraRegularMember ? 'alert-success': 'alert-danger' ">
                    <td>카라정기회원여부</td>
                    <td>
                        {{member.isKaraRegularMember ? '정기회원' : '비회원'}}
                    </td>
                </tr>
                <tr :class="member.isWithdraw ? 'alert-danger' : 'alert-success'">
                    <td>탈퇴여부</td>
                    <td>
                        {{member.isWithdraw ? '탈퇴' : '회원'}}
                        <button v-if="$auth.user().roleNames.includes('ADMIN')" :class="member.isWithdraw ? 'btn btn-outline-primary' :  'btn btn-outline-danger'"
                                @click="memberWithdraw">{{member.isWithdraw ? "이용재개" : "이용정지" }}</button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="modalFooter text-center">
                <h6 role="button" @click="close()">닫기</h6>
            </div>
        </div>
    </modal>
</template>

<script>
    import LevelHistoryModal from "./LevelHistoryModal";

    export default {
        name: "AdminMemberModal",
        components: {
            LevelHistoryModal
        },
        data() {
            return {
                memberId: 0,
                member : {
                    specialities: [],
                    gender : 0,
                },
                specialities: [],
                exp:0,
                tmp_password : "",
            }
        },
        methods: {
            close() {
                this.$modal.hide('AdminMemberModal')
            },
            beforeOpen (event) {
                this.member = event.params.member;
            },
            memberModified() {
                let me = this;

                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/member`, this.member)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('변경이 완료되었습니다.')
                        me.member = res.data;
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            memberWithdraw(){
                this.member.isWithdraw = !this.member.isWithdraw
                this.memberModified()
            },
            memberToggleIsDonation(){
                this.member.isDonation = !this.member.isDonation
                this.memberModified()
            },
            memberToggleIsEducatedOT(){
                this.member.isEducatedOT = !this.member.isEducatedOT
                this.memberModified()
            },
            memberChangeGender(){
                if(this.member.gender == "MALE"){
                    this.member.genderName = "남자"
                }else if(this.member.gender == "FEMALE"){
                    this.member.genderName = "여자"
                }else{
                    this.member.genderName = "기타"
                }

                this.memberModified()
            },
            addExp(){
                let me = this;

                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/member/${this.member.id}/exp/${this.exp}`)
                    .then(function () {
                        me.$root.$children[0].commonDialog('봉사시간이 부여 되었습니다.')
                        me.getMemberdata()
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });

            },
            memberAdmin(){
                let me = this;
                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/member/${this.member.id}`, this.member)
                    .then(function () {
                        me.$root.$children[0].commonDialog('권한이 변경 되었습니다.')
                        me.getMemberdata()
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });

            },
            memberPasswordReset(password){
                let me = this;

                if (password == '') {
                    this.$root.$children[0].commonDialog(this.requireInfoModalTitle, '비밀번호를 입력하세요.');
                    return;
                } else if (password.length < 8 || password.length > 12) {
                    this.$root.$children[0].commonDialog(this.requireInfoModalTitle, '비밀번호는 특수문자 포함 8자와 12자 사이로 입력해주세요.');
                    return;
                }

                this.axios.put(process.env.VUE_APP_ADMIN_API_URL + `/member/reset/${this.member.id}?tmp_password=${password.toString()}`)
                    .then(function () {
                        me.$root.$children[0].commonDialog('비밀번호가 변경 되었습니다.');
                        me.tmp_password = "";
                        me.getMemberdata();
                        document.getElementById('exampleModal').style.display = 'none';
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });

            },
            getSpecialityMap() {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + '/speciality') //JSON.parse(JSON.stringify(this.member))
                    .then(function (res) {
                        me.specialities = res.data;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            getMemberdata() {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + `/${this.member.id}`)
                    .then(function (res) {
                        me.member = res.data;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            popupToggle(title, text, callback) {
                this.$modal.show('dialog', {
                    title: title,
                    text: text,
                    buttons: [
                        {
                            title: title,
                            handler: () => {
                                callback();
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '취소'
                        },
                    ]
                })
            },
            showExpModal() {
                this.$modal.show('LevelHistoryModal')
            }
        },
        mounted() {
            this.getSpecialityMap()
        },
        created() {
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        z-index: 1050;
        max-height: 70%;
        max-width: 95%;
    }

    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
    .modalFooter {
        border-top: 1px solid #EEE;
        padding: 1em;
        text-align: center;
    }


</style>